module.exports = __webpack_public_path__ + "files/769852082976b91f311a62b60692fdef.png";